<template>
  <div class="header d-flex align-items-center justify-content-end">
    <img class="header-settings-icon"
         src="../assets/settings.png"
         v-popover:settings>

    <popover name="settings"
             :pointer="false"
             :width="250">
      <settings></settings>
    </popover>
  </div>
</template>

<script>
import Settings from './Settings'

import Popover from 'vue-js-popover'
import Vue from 'vue'

Vue.use(Popover)

export default {
  name: 'ChatHeader',

  components: {
    Settings
  }
}
</script>

<style lang="scss" scoped>
.header {
  height: 100%;

  &-settings-icon {
    display: block;
    height: 25px;
    margin-right: 3%;
    object-fit: contain;
    transition: transform .3s ease-in-out;

    &:hover {
      transform: rotate(360deg);
    }

    &:active {
      transform: scale(1.1);
    }
  }
}

/* set popover styles */
div[data-popover="settings"] {
  left: inherit !important;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue